import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import GlobalStyles from './styles';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";
import {store, persistor} from "./redux/store";
import * as Sentry from '@sentry/browser';
import { PersistGate } from 'redux-persist/integration/react'

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    attachStacktrace: true,
})

ReactDOM.render(
    <Provider store={ store }>
        <GlobalStyles />
        <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>
    , document.querySelector(store.getState().appElement));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
